var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',_vm._b({attrs:{"multiple":_vm.multiple},model:{value:(_vm.localModel),callback:function ($$v) {_vm.localModel=$$v},expression:"localModel"}},'el-select',_vm.$attrs,false),_vm._l((_vm.items),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }